import React from "react";
import { Carousel } from '@trendyol-js/react-carousel';
import { Link } from "react-router-dom";

/**
 * Componente para mostrar Nuestro Trabajo. Para la visualización se cargan a 
 * través de iteraciones en un carousel tomando la información desde el archivo
 *  .src/data/data.json -> "Briefcase"
 *
 * @component
 * @example
 * 
 * "Briefcase": [
    {
      "id": 1,
      "img": "/img/briefcase/Portafolio1.webp",
      "video": "/video/portafolio/video1.mp4",
      "alt": "Snackeros",
      "text": "Una plataforma digital creada para disfrutar de la comida sin reglas",
      "url": "/nuestrotrabajo/portafolio",
      "reto": "Invitar a los ecuatorianos a romper con lo establecido al momento de comer, creando contenido original no publicitario.",
      "insight": "Llevamos años condicionando la forma en que comemos; cocinamos los mismos platos y los consumimos de manera convencional.",
      "idea": "Creamos <b>“Snackeros”</b>, la primera plataforma transmedia donde rompimos las reglas culinarias, mostrando la forma más auténtica de disfrutar la comida.",
      "resultados": "Demostramos que generar contenido de valor puede superar los resultados de publicidad tradicional, logrando conectar con la audiencia de manera innovadora. <br><br> <b>Sobrepasamos la participación digital en un 115%</b>, aumentando el nivel de ventas significativamente. <b>Pasamos del top 10 al top 5 de marcas más preferidas</b> en la categoría de bebidas no alcohólicas.",
      "ejecucion": "",
      "text2": ""
    }
  ]
 */

export const Briefcase = (props) => {

    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

  if(props.data)
  {
    return (
      <div id="briefcase">
        <div>
        {width < breakpoint && props.home ?
          <div className="col-md-12" style={ width < breakpoint ? {paddingLeft: '0px', paddingRight: '0px'} : { } }>
            {props.data.map((d, i) => (
            <Link key={`lnk1${i}`} to={`${d.url}/${d.id}`}>
              <div className="dvCaption" key={`dv2${i}`}>
                <img className="img-responsive" key={`img${i}`} alt={d.name} src={d.img} />
                  <span className="caption" key={`text${i}`}>{d.text}</span>
              </div>
            </Link>
            ))}
          </div> 
      :
          <Carousel 
                show={width < breakpoint ? 1 : 3.2}
                slide={1} 
                swipeOn={0.2}
                transition={0.2} 
                responsive={true} 
                swiping={true}
                infinite={true}
                rightArrow={<div className={width < breakpoint ? "rightArrow-mob":"rightArrow"}>{``}</div>}
                leftArrow={<div className={width < breakpoint ? "leftArrow-mob":"leftArrow"}>{``}</div>}>
                  {props.data.map((d, i) => (
                    <Link key={`lnk${i}`} to={`${d.url}/${d.id}`}>
                        <div key={`dv1${i}`}>
                          <div className="dvCaption" key={`dv2${i}`}>
                              <img className="img-responsive" key={`img${i}`} alt={d.alt} src={d.img} />
                              <span className="caption" key={`text${i}`}>{d.text}</span>
                          </div>
                        </div>
                    </Link>
                  ))}
          </Carousel>
          
           }
        </div>
      </div>
    );
  }
  else
    return (<div></div>);
};
